import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";

import smokeVideo from "src/shared/assets/penAndLine/smoke.mp4";

export const SmokeVideo: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const timer1 = setTimeout(() => {
      videoRef.current?.play();
    }, 800);

    const timer2 = setTimeout(() => {
      videoRef.current.style.display = "none";
    }, 2500);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <Box
      sx={{
        position: "absolute",
        // inset: 0,
        // top: -184,
        // left: -100,
      }}
    >
      <video
        ref={videoRef}
        src={smokeVideo}
        preload="auto"
        muted
        width="100%"
      />
    </Box>
  );
};
